module.exports = __webpack_public_path__ + "static/img/service－image－2.c862085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service－image－2.png
// module id = 25Jz
// module chunks = 1